export const LABEL_APPNAME = 'Podeux';
export const LABEL_TAGLINE = 'Your shortcut to new podcasts.';
export const LABEL_DOMAIN = 'podeux.com';
export const IOS_APP_STORE_LINK = 'https://apps.apple.com/us/app/podeux/id6477985096';